import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getSeasonDropdownAsync } from './seasonThunk';
const initialState = {
    status: APIStatus.IDLE,
    seasonDropDownList: []
};
export const seasonSlice = createSlice({
    name: 'season',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSeasonDropdownAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getSeasonDropdownAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.seasonDropDownList = action.payload;
        })
            .addCase(getSeasonDropdownAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const {} = seasonSlice.actions;
export default seasonSlice.reducer;
